import { render, staticRenderFns } from "./sb_doc_create.vue?vue&type=template&id=3fd96c08&scoped=true&"
import script from "./sb_doc_create.vue?vue&type=script&lang=js&"
export * from "./sb_doc_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd96c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd96c08')) {
      api.createRecord('3fd96c08', component.options)
    } else {
      api.reload('3fd96c08', component.options)
    }
    module.hot.accept("./sb_doc_create.vue?vue&type=template&id=3fd96c08&scoped=true&", function () {
      api.rerender('3fd96c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/doc/create/sb_doc_create.vue"
export default component.exports